function panic() {

    console.log('lifecycle :', 'panic splash scene');
}

export {panic};
